export const SESSION_TIMEOUT_PATH = 'sessionTimeoutPath' as const;
export const REDIRECT_AFTER_RESET = 'redirectAfterReset' as const;

// The Digital Route Sheet's filter-group name, used to build its
// `filterOptions-<group>` storage key. Consumed by both
// ServiceExpress.jsx's <DashboardRepairOrderFilter filterGroup=...> mount
// and signout()'s localStorage clean-up — changing this value strands
// every existing user's stored Route Sheet filters, since the two call
// sites would then read/write different storage keys.
export const SERVICE_EXPRESS_FILTER_GROUP = 'service-express' as const;
